var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import TextInput from './TextInput';
/**
 *
 * @param {{
 *  onChange?: import('react').ChangeEventHandler;
 *  variant?: import('./inputVariants').InputVariant;
 *  placeholder?: string;
 *  rows?: number;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function Input(_a) {
    var { onChange, placeholder, rows = 3 } = _a, rest = __rest(_a, ["onChange", "placeholder", "rows"]);
    return (_jsx(TextInput, Object.assign({ as: "textarea", onChange: onChange, placeholder: placeholder, rows: rows }, rest)));
}
//# sourceMappingURL=TextArea.js.map